module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_LTGrey.e3e1fc6f.png";